// Input Masks
export const pcMask: any = [/[a-zA-Z]/, /\d/, /[a-zA-Z]/, ' ', /\d/, /[a-zA-Z]/, /\d/];
export const dateMask: any = [/[1-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

export const dateFormat = 'YYYY-MM-DD';
export const frDateFormat = 'YYYY-MM-DD';
export const enDateFormat = 'MMMM D[,] YYYY';

// Capacite
export const capaciteRevenuMinimum = 15000;
export const capaciteMiseMinimum = 1000;

// Date_picker angular material
export const YEAR_MONTH_FORMAT = {
  parse: {
    dateInput: 'YYYY MM'
  },
  display: {
    dateInput: 'YYYY-MM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
// Mise de fond
export const MIN_MISE_DE_FONDS_PERCENTAGE = 5;
export const MAX_MISE_DE_FONDS_PERCENTAGE = 99;
export const MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME = 20;
export const MISE_DE_FONDS_PREMIER_PALIER_PERCENTAGE = 5;
export const MISE_DE_FONDS_DEUXIEME_PALIER_PERCENTAGE = 10;
export const MISE_DE_FONDS_PREMIER_PALIER_MONTANT = 500000;

export const GTM_PUSH_CATEGORY = 'Parcours habitation';
export const GTM_PUSH_CATEGORY_FORMULAIRE = 'Formulaire';
export const GTM_PUSH_CATEGORY_ACTION = 'Action';

export const GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES = 'interractionsPages';
export const GTM_PUSH_CATEGORY_DRAWER = 'Tiroirs';
export const GTM_PUSH_CATEGORY_PAGE_VUE = 'pageVue';

export const GTM_PREAUTORISATION_EN_LIGNE = 'en ligne';
export const GTM_PREAUTORISATION_AVEC_COEMPRUNTEUR = 'coemprunteur';
export const GTM_PREAUTORISATION_SANS_COEMPRUNTEUR = 'unique';
export const GTM_PREAUTORISATION_ACCEPTEE = 'accepte';
export const GTM_PREAUTORISATION_REFUSEE = 'rejete';
export const GTM_PREAUTORISATION_LABEL = 'Parcours habitation - Preautorisation';

export enum StatusPreautorisation {
  EnAttente = 'EN_ATTENTE',
  EnAttenteTaux = 'EN_ATTENTE_TAUX',
  EnAttenteCoemprunteur = 'EN_ATTENTE_COEMPRUNTEUR',
  EnAttenteSelectionTaux = 'EN_ATTENTE_SELECTION_TAUX',
  Acceptee = 'ACCEPTEE',
  RefuseeSimplifie = 'REFUSEE_SIMPLIFIE',
  ContreOffreAcceptee = 'CONTRE_OFFRE_ACCEPTEE',
  ContreOffreEnAttente = 'CONTRE_OFFRE_EN_ATTENTE',
  ContreOffreRefusee = 'CONTRE_OFFRE_REFUSEE'
}

export const preautStatusWithDashboardContent: StatusPreautorisation[] = [
  StatusPreautorisation.Acceptee,
  StatusPreautorisation.EnAttente,
  StatusPreautorisation.EnAttenteTaux,
  StatusPreautorisation.RefuseeSimplifie,
  StatusPreautorisation.EnAttenteCoemprunteur,
  StatusPreautorisation.ContreOffreAcceptee,
  StatusPreautorisation.ContreOffreEnAttente,
  StatusPreautorisation.ContreOffreRefusee
];

export const shortMonthsNames = {
  fr: ['JAN', 'FÉV', 'MAR', 'AVR', 'MAI', 'JUN', 'JUL', 'AOÛ', 'SEP', 'OCT', 'NOV', 'DÉC'],
  en: ['JAN.', 'FEB.', 'MAR.', 'APR.', 'MAY', 'JUN.', 'JUL.', 'AUG.', 'SEP.', 'OCT.', 'NOV.', 'DEC.']
};
